module.exports = __webpack_public_path__ + "static/media/recruitment-mobile-2.7a81f9cf.png";